import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card card-flush pt-3 mb-5 mb-lg-10",
  "data-kt-subscriptions-form": "pricing"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header\"><div class=\"card-title\"><h2 class=\"fw-bolder\">Payment Method</h2></div><div class=\"card-toolbar\"><a href=\"#\" class=\"btn btn-light-primary\" data-bs-toggle=\"modal\" data-bs-target=\"#kt_modal_new_card\">New Method</a></div></div>", 1)
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = { id: "kt_create_new_payment_method" }
const _hoisted_5 = { class: "py-1" }
const _hoisted_6 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_7 = {
  class: "d-flex align-items-center collapsible toggle collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_create_new_payment_method_1",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2" }
const _hoisted_9 = { class: "svg-icon toggle-on svg-icon-primary svg-icon-2" }
const _hoisted_10 = { class: "svg-icon toggle-off svg-icon-2" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<img src=\"media/svg/card-logos/mastercard.svg\" class=\"w-40px me-3\" alt=\"\"><div class=\"me-3\"><div class=\"d-flex align-items-center fw-bolder\"> Mastercard <div class=\"badge badge-light-primary ms-5\">Primary</div></div><div class=\"text-muted\">Expires Dec 2024</div></div>", 2)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex my-3 ms-9" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-custom form-check-solid me-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input",
      type: "radio",
      name: "payment_method",
      checked: "checked"
    })
  ])
], -1)
const _hoisted_14 = {
  id: "kt_create_new_payment_method_1",
  class: "fs-6 ps-10 collapse",
  style: {}
}
const _hoisted_15 = { class: "d-flex flex-wrap py-5" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-equal me-5\"><table class=\"table table-flush fw-bold gy-1\"><tbody><tr><td class=\"text-muted min-w-125px w-125px\">Name</td><td class=\"text-gray-800\">Emma Smith</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Number</td><td class=\"text-gray-800\">**** 6129</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Expires</td><td class=\"text-gray-800\">12/2024</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Type</td><td class=\"text-gray-800\">Mastercard credit card</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Issuer</td><td class=\"text-gray-800\">VICBANK</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">ID</td><td class=\"text-gray-800\">id_4325df90sdf8</td></tr></tbody></table></div>", 1)
const _hoisted_17 = { class: "flex-equal" }
const _hoisted_18 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, " Billing address "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "AU")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Phone"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "No phone provided")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Email"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "text-gray-900 text-hover-primary"
    }, "e.smith@kpmg.com.au")
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Origin"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createTextVNode(" Australia "),
    /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-20px symbol-circle ms-2" }, [
      /*#__PURE__*/_createElementVNode("img", { src: "media/flags/australia.svg" })
    ])
  ])
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "CVC check", -1)
const _hoisted_24 = { class: "text-gray-800" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Passed ")
const _hoisted_26 = { class: "svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_28 = { class: "py-1" }
const _hoisted_29 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_30 = {
  class: "d-flex align-items-center collapsible toggle collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_create_new_payment_method_2"
}
const _hoisted_31 = { class: "btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2" }
const _hoisted_32 = { class: "svg-icon toggle-on svg-icon-primary svg-icon-2" }
const _hoisted_33 = { class: "svg-icon toggle-off svg-icon-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/svg/card-logos/visa.svg",
  class: "w-40px me-3",
  alt: ""
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center fw-bolder" }, "Visa"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "Expires Feb 2022")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex my-3 ms-9" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-custom form-check-solid me-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input",
      type: "radio",
      name: "payment_method"
    })
  ])
], -1)
const _hoisted_37 = {
  id: "kt_create_new_payment_method_2",
  class: "collapse fs-6 ps-10"
}
const _hoisted_38 = { class: "d-flex flex-wrap py-5" }
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-equal me-5\"><table class=\"table table-flush fw-bold gy-1\"><tbody><tr><td class=\"text-muted min-w-125px w-125px\">Name</td><td class=\"text-gray-800\">Melody Macy</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Number</td><td class=\"text-gray-800\">**** 1141</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Expires</td><td class=\"text-gray-800\">02/2022</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Type</td><td class=\"text-gray-800\">Visa credit card</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Issuer</td><td class=\"text-gray-800\">ENBANK</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">ID</td><td class=\"text-gray-800\">id_w2r84jdy723</td></tr></tbody></table></div>", 1)
const _hoisted_40 = { class: "flex-equal" }
const _hoisted_41 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, " Billing address "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "UK")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Phone"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "No phone provided")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Email"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "text-gray-900 text-hover-primary"
    }, "melody@altbox.com")
  ])
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Origin"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createTextVNode(" United Kingdom "),
    /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-20px symbol-circle ms-2" }, [
      /*#__PURE__*/_createElementVNode("img", { src: "media/flags/united-kingdom.svg" })
    ])
  ])
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "CVC check", -1)
const _hoisted_47 = { class: "text-gray-800" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Passed ")
const _hoisted_49 = { class: "svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_51 = { class: "py-1" }
const _hoisted_52 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_53 = {
  class: "d-flex align-items-center collapsible toggle collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_create_new_payment_method_3"
}
const _hoisted_54 = { class: "btn btn-sm btn-icon btn-active-color-primary ms-n3 me-2" }
const _hoisted_55 = { class: "svg-icon toggle-on svg-icon-primary svg-icon-2" }
const _hoisted_56 = { class: "svg-icon toggle-off svg-icon-2" }
const _hoisted_57 = /*#__PURE__*/_createStaticVNode("<img src=\"media/svg/card-logos/american-express.svg\" class=\"w-40px me-3\" alt=\"\"><div class=\"me-3\"><div class=\"d-flex align-items-center fw-bolder\"> American Express <div class=\"badge badge-light-danger ms-5\">Expired</div></div><div class=\"text-muted\">Expires Aug 2021</div></div>", 2)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex my-3 ms-9" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-custom form-check-solid me-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input",
      type: "radio",
      name: "payment_method"
    })
  ])
], -1)
const _hoisted_60 = {
  id: "kt_create_new_payment_method_3",
  class: "collapse fs-6 ps-10"
}
const _hoisted_61 = { class: "d-flex flex-wrap py-5" }
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-equal me-5\"><table class=\"table table-flush fw-bold gy-1\"><tbody><tr><td class=\"text-muted min-w-125px w-125px\">Name</td><td class=\"text-gray-800\">Max Smith</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Number</td><td class=\"text-gray-800\">**** 4625</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Expires</td><td class=\"text-gray-800\">08/2021</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Type</td><td class=\"text-gray-800\"> American express credit card </td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Issuer</td><td class=\"text-gray-800\">USABANK</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">ID</td><td class=\"text-gray-800\">id_89457jcje63</td></tr></tbody></table></div>", 1)
const _hoisted_63 = { class: "flex-equal" }
const _hoisted_64 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, " Billing address "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "US")
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Phone"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "No phone provided")
], -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Email"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "text-gray-900 text-hover-primary"
    }, "max@kt.com")
  ])
], -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Origin"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createTextVNode(" United States of America "),
    /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-20px symbol-circle ms-2" }, [
      /*#__PURE__*/_createElementVNode("img", { src: "media/flags/united-states.svg" })
    ])
  ])
], -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "CVC check", -1)
const _hoisted_70 = { class: "text-gray-800" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Failed ")
const _hoisted_72 = { class: "svg-icon svg-icon-2 svg-icon-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen036.svg" })
                ]),
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen035.svg" })
                ])
              ]),
              _hoisted_11
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("table", _hoisted_18, [
                  _createElementVNode("tbody", null, [
                    _hoisted_19,
                    _hoisted_20,
                    _hoisted_21,
                    _hoisted_22,
                    _createElementVNode("tr", null, [
                      _hoisted_23,
                      _createElementVNode("td", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("span", _hoisted_26, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen043.svg" })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("span", _hoisted_32, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen036.svg" })
                ]),
                _createElementVNode("span", _hoisted_33, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen035.svg" })
                ])
              ]),
              _hoisted_34,
              _hoisted_35
            ]),
            _hoisted_36
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("table", _hoisted_41, [
                  _createElementVNode("tbody", null, [
                    _hoisted_42,
                    _hoisted_43,
                    _hoisted_44,
                    _hoisted_45,
                    _createElementVNode("tr", null, [
                      _hoisted_46,
                      _createElementVNode("td", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("span", _hoisted_49, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_50,
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("span", _hoisted_55, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen036.svg" })
                ]),
                _createElementVNode("span", _hoisted_56, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen035.svg" })
                ])
              ]),
              _hoisted_57
            ]),
            _hoisted_59
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("table", _hoisted_64, [
                  _createElementVNode("tbody", null, [
                    _hoisted_65,
                    _hoisted_66,
                    _hoisted_67,
                    _hoisted_68,
                    _createElementVNode("tr", null, [
                      _hoisted_69,
                      _createElementVNode("td", _hoisted_70, [
                        _hoisted_71,
                        _createElementVNode("span", _hoisted_72, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}